'use client';

import { HomeIcon, RightArrowIcon } from '@tajdid/tajdid-ui/icons';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function HeaderBreadcrumb() {
  const location = usePathname();
  let currentLink = '';

  const crumbs = location
    .split('/')
    .filter(crumb => crumb !== '')
    .map(crumb => {
      currentLink += `/${crumb}`;

      return (
        <div className="flex items-center" key={crumb}>
          <RightArrowIcon className="mr-2 text-gray-300" />
          <Link className="text-gray-600 mt-1" href={currentLink}>
            {crumb
              .split('-')
              .map((word, index) =>
                index === 0
                  ? word.charAt(0).toUpperCase() + word.slice(1)
                  : word,
              )
              .join(' ')}
          </Link>
        </div>
      );
    });

  return (
    <div className="flex items-center gap-x-2">
      <Link href="/">
        <HomeIcon width={20} height={20} className="text-gray-500" />
      </Link>
      {crumbs}
    </div>
  );
}
